import MainButton from 'components/Buttons/CommonButton';
import { IconNames } from 'components/Input/Icon';
import React from 'react';
import styled from 'styled-components/macro';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  margin-bottom: 10px;
  align-items: center;
`;

const Content = styled.div<{ style?: React.CSSProperties }>`
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey5};
  border-radius: 4px;
  padding: 25px 15px;
  ${({ style }) => (style?.height ? `height: ${style.height};` : 'min-height: 30px;')}
`;

export const TitleSection = styled.h4`
  font-size: ${({ theme }) => theme.fontSizePalette.large};
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey9 : theme.colorPalette.grey.grey10};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
`;

export const WrapperBox = styled.div<{ visible?: boolean }>`
  ${(props) => !props.visible && 'display: none'};
`;

export interface ButtonProperty {
  buttonLabel?: string;
  isButtonActive?: boolean;
  buttonIcon?: IconNames;
  buttonAction?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export interface Props {
  title: string;
  hasButton?: boolean;
  children: React.ReactChild;
  visible?: boolean;
  buttonsProperty?: ButtonProperty[];
  style?: React.CSSProperties;
}

const Box = (props: Props) => {
  const { title, hasButton = false, visible = true, buttonsProperty, style } = props;
  return (
    <WrapperBox visible={visible}>
      <Header>
        <TitleSection>{title}</TitleSection>
        {hasButton && buttonsProperty?.length && (
          <div
            style={{
              display: 'flex',
            }}
          >
            {buttonsProperty?.map((button, index) => (
              <MainButton
                id={`box-button-${index}`}
                key={index}
                value={button.buttonLabel}
                scope="tertiary"
                action={button.buttonAction}
                customIcon={button.buttonIcon}
                disabled={!button.isButtonActive}
              />
            ))}
          </div>
        )}
      </Header>
      <Content style={style}>{props.children}</Content>
    </WrapperBox>
  );
};

export default Box;
